import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "@/context/AuthContext";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const [state, setState] = useState({ status: "working", message: "Verifying…" });
  const attempted = useRef(false);

  useEffect(() => {
    if (attempted.current) return;
    attempted.current = true;
    const token = params.get("token");
    if (!token) {
      setState({ status: "error", message: "No verification token provided." });
      return;
    }
    api.post("/auth/verify-email", { token })
      .then((res) => setState({ status: "ok", message: res.data.message }))
      .catch((err) => setState((prev) => prev.status === "ok" ? prev : { status: "error", message: formatApiError(err) }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="card max-w-xl space-y-4" data-testid="verify-email-page">
      <h1 className="text-base md:text-lg font-semibold">Email verification</h1>
      <p role={state.status === "error" ? "alert" : undefined} data-testid="verify-email-message">
        {state.message}
      </p>
      {state.status === "ok" && (
        <Link to="/login" className="btn-primary inline-block" data-testid="verify-login-link">Log in</Link>
      )}
    </div>
  );
}
